import { Component, Injector, Input, OnInit, Output } from '@angular/core';
import { AgricultureMapConstants, BASE_LAYER_LIST, COMMON_LAYER_LIST, COMPONENT_ROUTE_MAPPING, LAYER_TYPES, LOCATIONS_LATLNG, LOCATIONS_ZOOM, MAP_OPTIONS } from '../../constants/dims-map-constants';
import * as L from 'leaflet';
import 'src/assets/js/maplibs/L.control.HtmlLegend.js';
import 'src/assets/map-control/L.Control.ZoomBar.js';
import 'src/assets/js/maplibs/L.TileLayer.NoGap.js'
import { GisdataService } from '../../services/gisdata.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { takeUntil } from 'rxjs/operators';
import { AgricultureDashboardDefaultParams, AgricultureDashboardRequiredParams } from '../../constants/dims-queryparams-constants';
import { Subject } from 'rxjs';
import { DataService } from '../services/data.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { MapService } from 'src/app/utils/map.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import * as domtoimage from 'src/assets/js/maplibs/print/dom-to-image.js'
import { PixiLayerService } from '../pixi/pixi-layer.service';
import { isPixiPointsLayer } from '../pixi/pixi-points-layer';

@Component({
  selector: 'app-gis-nhip-map',
  templateUrl: './gis-nhip-map.component.html',
  styleUrls: ['./gis-nhip-map.component.scss']
})
export class GisNhipMapComponent implements OnInit {
  @Input() infoboxComponent: any;
  @Input() otherOptions: any;
  @Input() sidebarComponent: any;
  @Input() navbarComponent: any;
  // @Input() count1: any;

  injectedService: any;
  queryParams: any = {};
  agricultureDefaultParams: any;
  paramsSubscription: any;
  map: any;
  layers: any = {
    baselayers: {},
    overlaylayers: {},
    heatmaplayers: {},
    stationlayers: {},
    stationlayersQC: [],
    aoiLayers: {},
    processedLayers: {},
    clickedBoundaryLayers: {}
  }
  activeLayers: any = {};
  // Bumped every time a new hazard-layer request starts (handleHazardLayers); lets async
  // GEOJSON/WFS fetches (e.g. Cyclone Line) detect they've been superseded by a later hazard
  // switch and avoid re-adding themselves to the map / re-flagging activeLayers after cleanup.
  hazardRequestToken: number = 0;
  mapId: any;
  componentType: any;
  dashboardType: any;
  selectedCommonLayers: any = '';
  metaInfo: any = {};
  userLocationConfig: any = {};
  componentWiseData: any = {};
  dashboard: any;
  dataTabCSS: any;
  destroy: Subject<boolean> = new Subject<boolean>();
  url: any;
  params: any = {};
  routeParams: any = {
    component: null,
    dashboard: null
  }
  userLocType: any;
  htmlNewLegend: any;
  legendList: any = {};
  dataTabToggleVal = false
  labelStrings = []
  activeSideMenu: any;
  playButtonDisable = true;
  playPosition = 0;
  playFastSlow: boolean = false;
  activeGroup: any;
  blockNumber = 0;
  dateBlockNumMap: any = {};
  cityAlertsDisable: boolean = true;
  activeButton: any = 'Admin'
  hwMetaData = {}
  showLabels: any = {
    COUNTRY: false,
    STATE: false,
    DISTRICT: false
  }
  selectedTimeStamp: any;
  showThrobber: boolean = false;
  selectedSource: any
  basemapInitialized: boolean = false;
  counter: number;
  initialCounter: number;
  visitorCount: any = '6753';
  deviceInfo: any;
  type: any;
  actualView: any = 'HEATMAP';
  titleTag = {
    'wind-speed-forecast': ' - 10m above surface',
    'temperature-forecast': ' - 2m above surface',
    'humidity-forecast': ' - 2m above surface',
    'WIND': ' - 10m above surface',
    'TEMPERATURE': ' - 2m above surface',
    'HUMIDITY': ' - 2m above surface',
    'RAINFALL': ''
  }
  isLayerListClick: boolean = false;
  rfActualQCSrcList: any = {}
  stationlayerType: any = { 'Valid Stations': false, 'Invalid Stations': true }
  typeColorMapping: any = { 'Valid Stations': '#66ff66', 'Invalid Stations': '#ffad33' }
  isImageSliderOpen: boolean = false;
  timerange: any = null;
  connectionLines: any = {
    school: null,
    hospital: null,
    earthquake: null,
    cyclone: null,
    faultLine: null,
    schoolMarker: null,
    hospitalMarker: null,
    earthquakeMarker: null,
    cycloneMarker: null,
    faultGeometry: null
  };
  locationInfoControl: any = null;
  isLocationOnlyMode: boolean = false;
  pointClickHandler: any = null;
  showMapThrobber: boolean = false
  constructor(public gisdataService: GisdataService,
    private injector: Injector,
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataService,
    private gisUtils: UtilsService,
    public mapService: MapService,
    private deviceService: DeviceDetectorService,
    private pixiLayerService: PixiLayerService,
  ) {
    this.url = this.router.url.split('?')[0];
    let splitUrl: any = this.url.split('/');
    // console.log("splitUrl",splitUrl);

    this.routeParams.component = splitUrl[splitUrl.length - 2];
    this.routeParams.dashboard = splitUrl[splitUrl.length - 3];
    if (splitUrl.includes('24')) {
      this.routeParams.component = splitUrl[splitUrl.length - 3];
      this.routeParams.dashboard = splitUrl[splitUrl.length - 4];
    }
    // console.log("routeParams:::",this.routeParams);

    this.deviceInfo = this.deviceService.getDeviceInfo();
  }

    ngOnInit(): void {
    this.mapId = 'map-' + this.otherOptions.mapId;
    this.revalidateMap();
    this.initializeMapContainer();
    // this.subscribeParams();
  }

  ngAfterViewInit(): void {
    this.revalidateMap();
    return;
  }

  revalidateMap(): void {
    window.dispatchEvent(new Event('resize'));
    if (this.map) {
      setTimeout(() => {
        this.map.invalidateSize();
      }, 200)
    }
  }


  initializeMapContainer() {
    setTimeout(() => {
      MAP_OPTIONS['editable'] = true;
      // preferCanvas is scoped to this map instance (not mutated onto the shared
      // MAP_OPTIONS constant) so GeoJSON boundary layers render via Canvas instead of
      // SVG here only — html2canvas (used for map/report PDF export) rasterizes
      // canvas-drawn vector layers far more reliably than the default SVG renderer.
      this.map = (L.map as any)(this.mapId, { ...MAP_OPTIONS, preferCanvas: true });
      const mapContainer = this.map.getContainer()
      if (this.routeParams.component == 'rainfall-actual' || this.routeParams.component == 'rainfall-actual-qc') {
        mapContainer.classList.add('leaftet-custom-container')
      }
      // for cold wave map background color changes
      // if(this.routeParams.component == 'coldwave') {
      //   console.log("this.routeParams.component",this.routeParams.component);
      //   // mapContainer.classList.add('')
      //   mapContainer.classList.add('leaftet-coldwave-container')
      // }
      this.map.setView(LOCATIONS_LATLNG[AgricultureMapConstants.LOCATIONS.INDIA], LOCATIONS_ZOOM[AgricultureMapConstants.LOCATIONS.INDIA]);
      this.createPanes();
      this.addZoomBar();
      this.getAndSetBaseLayers(3);
      this.subscribeEvents();
      // if(this.otherOptions.mapId == "mainGeoportal" || this.otherOptions.mapId == "analyticsMap"){
      //   this.addCoordinates();
      // }
      // this.gisUtils.getGisMapComp.next(this);
    }, 10);
  }

  private createPanes() {
    AgricultureMapConstants.PANE_LIST.forEach((pane: any) => {
      this.map.createPane(pane.name);
      this.map.getPane(pane.name).style.zIndex = pane.zindex;
    });
  }

  addZoomBar() {
    let zoomBarControl = new (L as any).control.zoomBar();
    zoomBarControl.addTo(this.map);
  }
  getAndSetBaseLayers(index) {
    let tileLayers = this.gisdataService.addBaseTileLayers(BASE_LAYER_LIST[LAYER_TYPES.TILE_LAYER], index, this.map)
    this.layers.baselayers = Object.assign(tileLayers, {});
  }

  private subscribeEvents() {
    this.componentType = this.routeParams.component //this.gisdataService.isEmptyObj(this.route.snapshot.params) ? '' : this.route.snapshot.params['component'];
    this.type = (this.routeParams.dashboard == 'weatherforecast' || this.routeParams.dashboard == 'nowcastweather') ? this.routeParams.dashboard : this.componentType
    // this.componentType = this.router.url.split('/').includes('satelliteDataProcessing') ? 'satelliteDataProcessing' : this.componentType;
    this.dashboard = this.router.url.includes('download') ? 'download' : '';
    this.dashboardType = this.dashboard ? this.dashboard : this.router.url.split('?')[0].split('/')[3];
    this.dataTabCSS = this.router.url.split('?')[0].split('/')[4];
    this.revalidateMap()
    this.selectedCommonLayers = AgricultureMapConstants.DASHBOARD_WISE_COMMON_LAYERS_KEY_MAPPING[this.componentType];
    this.injectedService = this.injector.get(this.otherOptions['serviceType']);
    // getting metaInfo
    let metaInfo: any = localStorage.getItem('metaInfo');
    let metaInfoJson: any = !isNullOrUndefined(metaInfo) ? JSON.parse(metaInfo) : {};
    this.metaInfo = metaInfoJson;
    if (Object.keys(metaInfoJson).length > 0) {
      if (metaInfoJson && metaInfoJson.hasOwnProperty('userDetailsJson') && !isNullOrUndefined(metaInfoJson.userDetailsJson) && this.componentType != 'kolkataEvent' && this.componentType != 'kolkata2025' && this.componentType != 'jammuEvent') {
        this.userLocType = metaInfoJson.userDetailsJson.data.locType;
        this.userLocationConfig = this.dataService.formQuerParamsVariables(metaInfoJson.userDetailsJson.data.location, this.userLocType);
        this.setQueryParams(this.userLocationConfig);
      } else if (metaInfoJson && metaInfoJson.hasOwnProperty('userDetailsJson') && !isNullOrUndefined(metaInfoJson.userDetailsJson) && (this.componentType == 'kolkataEvent' || this.componentType == 'kolkata2025')) {
        this.userLocType = 'State'
        this.userLocationConfig = this.dataService.formQuerParamsVariables({
          "country": [
            {
              "countryName": "India",
              "countryUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
              "state": [
                {
                  "stateName": "West Bengal",
                  "stateUUID": "119ff4d9-357d-46e7-a33a-341a10e2e26f",//"78170895-ec7a-42d6-b39f-2c4eaa001944"
                  "district": [
                    {
                      "districtName": "Kolkatta",
                      "districtUUID": "a755d090-4d93-47d3-91d6-d0c1b0f2a397"
                    }
                  ]
                }
              ]
            }
          ]
          // "country":[{"countryName":"INDIA","countryUUID":"00cb31c7-2928-4e6d-adcc-443d478c90d6","state":[{"stateName":"ASSAM","stateUUID":"0a2f9e86-49fa-4641-af48-f127a02a1a14","district":[{"districtName":"KAMRUP","districtUUID":"d7931e9c-bf3d-4b12-8e63-bb567d65228c"}]}]}]
        }, this.userLocType);
        this.setQueryParams(this.userLocationConfig);
      } else if (metaInfoJson && metaInfoJson.hasOwnProperty('userDetailsJson') && !isNullOrUndefined(metaInfoJson.userDetailsJson) && this.componentType == 'jammuEvent') {
        this.userLocType = 'State'
        this.userLocationConfig = this.dataService.formQuerParamsVariables({
          "country": [
            {
              "countryName": "India",
              "countryUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
              "state": [
                {
                  "stateName": "Jammu And Kashmir",
                  "stateUUID": "3d62dad7-cca9-4b02-aff7-220a1e29434a",//"78170895-ec7a-42d6-b39f-2c4eaa001944"
                }
              ]
            }
          ]
          // "country":[{"countryName":"INDIA","countryUUID":"00cb31c7-2928-4e6d-adcc-443d478c90d6","state":[{"stateName":"ASSAM","stateUUID":"0a2f9e86-49fa-4641-af48-f127a02a1a14","district":[{"districtName":"KAMRUP","districtUUID":"d7931e9c-bf3d-4b12-8e63-bb567d65228c"}]}]}]
        }, this.userLocType);
        this.setQueryParams(this.userLocationConfig);
      }
    } else {
      this.router.navigate(['/'])
    }
    this.paramsSubscription = this.gisUtils.selectedParams.pipe(takeUntil(this.destroy)).subscribe((params: any) => {
      if (!this.gisdataService.isEmptyObj(params)) {
        let routeParams: any = this.routeParams; //this.gisdataService.getWritableObject(this.route.snapshot.params);
        if (Object.keys(routeParams).length == 0) {
          routeParams = {
            component: 'cropAnalytics',
            dashboard: 'agriculture'
          };
        }

        if ((COMPONENT_ROUTE_MAPPING[params['component']] &&
          COMPONENT_ROUTE_MAPPING[params['component']] == routeParams['component']) || params['component'] == 'satelliteDataProcessing') {

          this.params = JSON.parse(JSON.stringify(params));
          this.revalidateMap();
          this.initMethods();
        }
      }
    });
    // this.aoiParamsSubscription = this.gisUtils.aoiSelectedParams.subscribe((params: any) => {
    //   if (Object.keys(params).length > 0) {
    //     this.aoiParams = params;
    //     if (this.otherOptions.hasOwnProperty('aoiFunctionName')) {
    //       this.injectedService[this.otherOptions.aoiFunctionName](this);
    //     }
    //   }
    // });
    // this.dataTabSubscription = this.gisUtils.toggleSide.subscribe(event => {
    //   // this.toggleButtonsLeft['dataTabToggle'] = event;
    //    // First, reset all buttons to false
    //   for (const key in this.toggleButtonsLeft) {
    //     if (this.toggleButtonsLeft.hasOwnProperty(key)) {
    //       this.toggleButtonsLeft[key] = false;
    //     }
    //   }
    //   for (const key in this.toggleButtons) {
    //     if (this.toggleButtons.hasOwnProperty(key)) {
    //       this.toggleButtons[key] = false;
    //     }
    //   }
    //   // Then set the provided key to true
    //   const key = Object.keys(event)[0];
    //   if (key && this.toggleButtonsLeft.hasOwnProperty(key)) {
    //     this.toggleButtonsLeft[key] = event[key];
    //   }
    //   // this.toggleButtonsLeft['drawingTool'] = !event;
    //   if(this.routeParams.component == 'cropSownInformation') {
    //     this.toggleButtonsLeft['infoboxToggle'] = event[key];
    //   }
    // })
    // this.enableToolSubscription = this.gisUtils.enabledTools.subscribe(event => {
    //   if(this.toggleButtonsLeft['dataTabToggle']){
    //     this.toggleButtonsLeft['drawingTool'] = false;
    //   }
    // })
    // this.weatherForecastSidebarSub = this.gisUtils.getSidebarToggle().subscribe(data => {
    //   this.sidebarToggle = data;
    // })
    // this.weatherForecastSrv.getHieViewType().subscribe((hieType:any) => {
    //   this.weatherForecastHieType = hieType;
    //   let options: any = JSON.parse(JSON.stringify(this.route.snapshot.queryParams))
    //   options['hieType'] = isNullOrUndefined(this.weatherForecastHieType) ? 'Agri' : this.weatherForecastHieType;
    //   this.url = this.router.url.split('?')[0];
    //   let splitUrl: any = this.url.split('/');
    //   if(splitUrl.includes('weatherForecast')){
    //     this.router.navigate(['.'], {
    //       relativeTo: this.route,
    //       queryParams: options,
    //       queryParamsHandling: 'merge'
    //     });
    //   }
    // });
    //updating header count on radio button active in coldwave
    if (this.componentType === 'coldwave') {
      this.gisUtils.coldwaveIndex$
        .pipe(takeUntil(this.destroy))
        .subscribe(groupName => {
          if (!groupName) return;
          this.changeTimeLayers(groupName);
        });
    }
  }

  setQueryParams(userLocationConfig: any) { // setting params on the basis of metaInfo
    this.url = this.router.url.split('?')[0];
    let splitUrl: any = this.url.split('/');
    this.route.queryParamMap.subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams[param] = params[param];
        }
      }
      this.agricultureDefaultParams = this.dataService.deepClone(AgricultureDashboardDefaultParams);
      const mergedParams = this.dataService.deepMerge(this.agricultureDefaultParams, this.queryParams);
      if (!isNullOrUndefined(userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()])) {
        let currentLocations: any = userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()].split('##');
        mergedParams['dashboardType'] = 'gis';
        mergedParams['pUUID'] = currentLocations[1]
        mergedParams['locName'] = currentLocations[0]
        mergedParams['locType'] = userLocationConfig.types.pType;
        mergedParams['pEUUID'] = userLocationConfig.locationInfo.country.split('##')[1];
        mergedParams['location'] = userLocationConfig.locationInfo.location;
        // mergedParams['source'] = this.componentType != 'thunderstorm' ? 'IMD_LONG_RANGE' : 'ECMWF_KINDEX'
        mergedParams['view'] = 'Admin'
        mergedParams['hazardView'] = 'multiHazard'
      }

      if (!this.dataService.verifyAllParamsPresent(this.queryParams['params'], JSON.parse(JSON.stringify(AgricultureDashboardRequiredParams)))) {
        this.router.navigate(['.'], {
          relativeTo: this.route,
          queryParams: mergedParams,
          queryParamsHandling: 'merge'
        });
      }
      else {
        // this.removeAllLayers();
        this.initMethods();
      }

    });
  }

  initMethods() {    
    // this.gisUtils.selectedFieldEvent.next({});    
    if (this.params['actionType'] == 'filter') {
      this.removeAllLayers();
      this.removeComponentWiseLayers();
      this.removeHeatMapLayers();
      this.injectedService[this.otherOptions['functionName']](this);
    } else {
      this.removeAllLayersExceptNHIP()
      this.injectedService[this.otherOptions['functionName']](this);
    }
    this.getAndSetUserLoginBasedLayers();
    // if(this.componentType == 'heatwave') {
    // }
  }

  setSelectedTimestamp() {
    this.gisUtils.getTimeStamp().subscribe(data => {
      this.selectedTimeStamp = data;
    })
  }

  async getAndSetUserLoginBasedLayers() {
    if (this.queryParams['params']['pUUID'] != '') {
      let dashboadWiseCommonLayers: any = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS[this.selectedCommonLayers]];
      if (Object.keys(dashboadWiseCommonLayers).length > 0 && !this.otherOptions.dontRenderCommonLayers) {
        this.addLocationWiseLayers(this.queryParams['params'], dashboadWiseCommonLayers);
      }
    }
    // let pUUID: any = this.queryParams.params.pUUID;
    // if (this.queryParams.params.pUUID != '') {
    //   let response: any = await this.getHighlightedLayer(locTypeMapping, pType, pUUID);
    //   let data: any = new L.GeoJSON(response.data);
    //   let bounds: any = data.getBounds();
    //   if (Object.keys(bounds).length > 0) {
    //     this.map.fitBounds(data.getBounds());
    //   }
    //   this.map.addLayer(this.layers.overlaylayers[pType]);
    //   this.spinner = false;
    // }
  }

  addLocationWiseLayers(queryParams: any, dashboadWiseCommonLayers: any) {
    let layersList: any = {};
    if (!isNullOrUndefined(queryParams.locType) && !this.otherOptions.dontLoadUserBasedLocation) {
      layersList[this.gisUtils.titleCase(queryParams.locType)] = dashboadWiseCommonLayers[this.gisUtils.titleCase(queryParams.locType) + ' Boundaries'];
      let geoJsonLayersBasedOnView = this.gisdataService.getApplicationBasedLayer(layersList, LAYER_TYPES.GEOJSON_LAYER);
      geoJsonLayersBasedOnView = this.formatLayersData(geoJsonLayersBasedOnView);
      this.addSrcWiseGEOJSONLayers(geoJsonLayersBasedOnView);
      this.addLocationWiseWMSLayers(queryParams);
    }
  }

  formatLayersData(layerList: any) {
    for (let layerName in layerList) {
      if (layerList[layerName].layerOptions.cql_filter_value) {
        layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + this.queryParams.params['pUUID'] + "'";
      }
    }
    return layerList;
  }

  addLocationWiseWMSLayers(queryParams: any) {
    let wmsLayerList: any = {};
    let currentLocType: any = queryParams.locType;
    let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
    let nextLevel: any = hie[hie.indexOf(currentLocType) + 1];
    let layerName: any = this.gisUtils.titleCase(nextLevel) + ' Boundary';
    // wmsLayerList[layerName] = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][layerName];
    // wmsLayerList[layerName+' Labels'] = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][layerName+' Labels'];
    // if (layerName != 'Farm Boundary') {
    //   let wmsLayersBasedOnView = this.gisdataService.getApplicationBasedLayer(wmsLayerList, LAYER_TYPES.WMS_LAYER);
    //   wmsLayersBasedOnView = this.formatWmsLayersData(wmsLayersBasedOnView, queryParams);
    //   this.addSrcWiseWMSLayers(wmsLayersBasedOnView);
    if (queryParams['locType'] == 'COUNTRY') {

      wmsLayerList[layerName] = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][layerName];
    }
    // if(!layerName.includes("State")) {
    // if((this.routeParams.component == 'cropAnalytics' || this.routeParams.component == 'plotAddition' || this.routeParams.component == 'cropSownInformation') && queryParams.locType == 'DISTRICT') {
    //   wmsLayerList['District Labels'] = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['District Boundary Labels'];
    // } else if((this.routeParams.component == 'cropAnalytics' || this.routeParams.component == 'plotAddition'|| this.routeParams.component == 'cropSownInformation') && queryParams.locType == 'BLOCK') {
    //   wmsLayerList['Block Labels'] = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['Block Boundary Labels'];
    // }
    // else if((this.routeParams.component == 'cropAnalytics' || this.routeParams.component == 'plotAddition'|| this.routeParams.component == 'cropSownInformation') && queryParams.locType == 'PANCHAYAT') {
    //   wmsLayerList['Panchayat Labels'] = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['Panchayat Boundary Labels'];
    // }
    // else if((this.routeParams.component == 'cropAnalytics' || this.routeParams.component == 'plotAddition'|| this.routeParams.component == 'cropSownInformation') && queryParams.locType == 'VILLAGE') {
    //   wmsLayerList['Village Labels'] = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['Village Boundary Labels'];
    // }
    if (queryParams['locType'] != 'COUNTRY') {
      wmsLayerList[layerName + ' Labels'] = COMMON_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][layerName + ' Labels'];
    }
    // }
    // if(layerName != 'Farm Boundary'){
    let wmsLayersBasedOnView = this.gisdataService.getApplicationBasedLayer(wmsLayerList, LAYER_TYPES.WMS_LAYER);
    wmsLayersBasedOnView = this.formatWmsLayersData(wmsLayersBasedOnView, queryParams);
    this.addSrcWiseWMSLayers(wmsLayersBasedOnView);
    // }
    // }
  }
  // formatWmsLayersData(layerList: any, queryParams?: any) {
  //   if (!isNullOrUndefined(queryParams)) {
  //     for (let layerName in layerList) {
  //       if (layerList[layerName].layerOptions.cql_filter_value) {
  //         let uuid: any = this.getLocationUUID(queryParams, layerList[layerName].layerOptions);
  //         layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + uuid + "'";
  //       }
  //     }
  //     return layerList;
  //   }
  // }
  formatWmsLayersData(layerList: any, queryParams?: any) {
    if (!isNullOrUndefined(queryParams)) {
      for (let layerName in layerList) {
        if (layerList[layerName].layerOptions.cql_filter_value) {
          let uuid: any = this.getLocationUUID(queryParams, layerList[layerName].layerOptions);
          layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + uuid + "'";
          // if(this.routeParams.component == 'cropAnalytics' || this.routeParams.component == 'plotAddition'|| this.routeParams.component == 'cropSownInformation') {
          if (queryParams.locType == 'STATE') {
            if (layerName == 'District Boundary Labels') {
              let allLocations: any = queryParams.location.split('&');
              let puuid = allLocations[1].split('##')[1]
              layerList[layerName].layerOptions.cql_filter_value = 'State_UUID'
              layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + puuid + "'";
            } else if (layerName == 'District Labels') {
              let allLocations: any = queryParams.location.split('&');
              let puuid = allLocations[2].split('##')[1]
              layerList[layerName].layerOptions.cql_filter_value = 'district_uuid'
              layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + puuid + "'";
            }
          }
          if (queryParams.locType == 'BLOCK') {
            if (layerName == 'Block Labels') {
              let allLocations: any = queryParams.location.split('&');
              let puuid = allLocations[3].split('##')[1]
              layerList[layerName].layerOptions.cql_filter_value = 'block_uuid'
              layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + puuid + "'";
            } else if (layerName == 'Panchayat Boundary Labels') {
              let allLocations: any = queryParams.location.split('&');
              let puuid = allLocations[3].split('##')[1]
              layerList[layerName].layerOptions.cql_filter_value = 'mandal_uui'
              layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + puuid + "'";
            }
          }
          if (queryParams.locType == 'PANCHAYAT') {
            if (layerName == 'Panchayat Labels') {
              let allLocations: any = queryParams.location.split('&');
              let puuid = allLocations[4].split('##')[1]
              layerList[layerName].layerOptions.cql_filter_value = 'uuid'
              layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + puuid + "'";
            } else if (layerName == 'Village Boundary Labels') {
              let allLocations: any = queryParams.location.split('&');
              let puuid = allLocations[4].split('##')[1]
              layerList[layerName].layerOptions.cql_filter_value = 'panchayat_uuid'
              layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + puuid + "'";
            }
          }
          if (queryParams.locType == 'VILLAGE') {
            if (layerName == 'Village Labels') {
              let allLocations: any = queryParams.location.split('&');
              let puuid;
              if (this.routeParams.component == 'plotAddition') {
                puuid = allLocations[4].split('##')[1]
              } else {
                puuid = allLocations[5].split('##')[1]
              }
              layerList[layerName].layerOptions.cql_filter_value = 'village_uuid'
              layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + puuid + "'";
            }
          }
          // }
        }
      }
      return layerList;
    }
  }

  getLocationUUID(queryParams: any, options: any) {
    let allLocations: any = queryParams.location.split('&');
    let uuid: any = '';
    if (options.layer_name == 'State Boundary' || options.layer_name == 'State Boundary Labels') {
      uuid = allLocations[1].split('##')[1]
    } else if (options.layer_name == 'District Boundary' || options.layer_name == 'District Boundary Labels') {
      uuid = allLocations[1].split('##')[1]
    } else if (options.layer_name == 'Block Boundary' || options.layer_name == 'Block Boundary Labels') {
      uuid = allLocations[2].split('##')[1]
    } else if (options.layer_name == 'Panchayat Boundary' || options.layer_name == 'Panchayat Boundary Labels') {
      uuid = allLocations[3].split('##')[1]
    } else if (options.layer_name == 'Village Boundary' || options.layer_name == 'Village Boundary Labels') {
      uuid = allLocations[4].split('##')[1]
    }
    //  else if (options.layer_name == 'Village Farm Level Boundary') {
    //   uuid = allLocations[4].split('##')[1]
    // }
    return uuid;
  }

  // addSrcWiseWMSLayers(wmsLayersBasedOnView: any) {
  //   this.layers.overlaylayers = Object.assign({}, this.layers.overlaylayers, this.gisdataService.setWMSOverlays(this.map, wmsLayersBasedOnView, this.layers.overlaylayers));
  // }
addSrcWiseWMSLayers(wmsLayersBasedOnView: any) {
  this.layers.overlaylayers = Object.assign(
    {},
    this.layers.overlaylayers,
    this.gisdataService.setWMSOverlays(
      this.map,
      wmsLayersBasedOnView,
      this.layers.overlaylayers
    )
  );
  this.manageLegend();
}

  // addSrcWiseVECTORLayers(vectorLayersBasedOnView: any) {
  //   this.layers.overlaylayers = Object.assign({}, this.layers.overlaylayers, this.gisdataService.setVECTOROverlays(this.map, vectorLayersBasedOnView, null, this.layers.overlaylayers, this.params, this.queryParams.params, this));
  // }
  addSrcWiseVECTORLayers(vectorLayersBasedOnView: any) {
  this.layers.overlaylayers = Object.assign(
    {},
    this.layers.overlaylayers,
    this.gisdataService.setVECTOROverlays(
      this.map,
      vectorLayersBasedOnView,
      null,
      this.layers.overlaylayers,
      this.params,
      this.queryParams.params,
      this
    )
  );
  this.manageLegend();
}


  // addSrcWiseGEOJSONLayers(geoJsonLayersBasedOnView: any) {
  //   this.gisdataService.setGEOJSONOverlays(this.map, geoJsonLayersBasedOnView, this.layers, this.otherOptions, this).then(data => {
  //     Object.keys(data).forEach(key => {
  //       this.activeLayers[key] = true;});
  //     this.manageLegend();
  //     this.layers.overlaylayers = Object.assign({}, this.layers.overlaylayers, data);
  //     // if (this.params.component && this.componentType != 'satelliteDataProcessing') {
  //     //   this.manageLegend();
  //     // }
  //     // if ((this.params.component && this.componentType != 'satelliteDataProcessing') || this.routeParams.component == 'cropSownInformation') {
  //     this.manageLegend();
  //     // }
  //   });
  // }
addSrcWiseGEOJSONLayers(geoJsonLayersBasedOnView: any) {

  if (this.isLocationOnlyMode) {

    const filteredLayers: any = {};

    Object.keys(geoJsonLayersBasedOnView).forEach(key => {
      if (key === 'Country Boundaries') {
        filteredLayers[key] = geoJsonLayersBasedOnView[key];
      }
    });

    geoJsonLayersBasedOnView = filteredLayers;
  }

  // Snapshot the request generation; if the hazard type changes before this (possibly async
  // WFS-backed) fetch resolves, drop its hazard layers so a stale one (e.g. Cyclone Line) can't
  // re-mark itself active or overwrite the newer layer's reference. Boundaries are still kept.
  const requestToken = this.hazardRequestToken;

  this.gisdataService
    .setGEOJSONOverlays(
      this.map,
      geoJsonLayersBasedOnView,
      this.layers,
      this.otherOptions,
      this
    )
    .then(data => {
      if (requestToken !== this.hazardRequestToken) {
        Object.keys(data).forEach(key => {
          if (data[key] && data[key].options && data[key].options.group === 'Hazard') {
            delete data[key];
          }
        });
      }

      Object.keys(data).forEach(key => {
        // Overlapping requests (a hazard switch reloads the base layers twice) can each add the same
        // boundary; drop the previously tracked copy so it isn't left orphaned on the map.
        const previous = this.layers.overlaylayers[key];
        if (previous && previous !== data[key] && this.map.hasLayer(previous)) {
          this.map.removeLayer(previous);
        }
        this.activeLayers[key] = true;
      });

      this.layers.overlaylayers = Object.assign({}, this.layers.overlaylayers, data);
      this.manageLegend();
    });
}


  addSrcWisePIXILayers(pixiLayersBasedOnView: any) {
    // Same stale-request guard as addSrcWiseGEOJSONLayers: a hazard change while the WFS fetch is in
    // flight bumps hazardRequestToken, and the late result must not be added to the map.
    const requestToken = this.hazardRequestToken;
    for (const key in pixiLayersBasedOnView) {
      const config = pixiLayersBasedOnView[key];
      this.pixiLayerService.loadLayer(config, this.injectedService).subscribe(layer => {
        if (requestToken !== this.hazardRequestToken || this.isLocationOnlyMode) {
          return;
        }
        const previous = this.layers.overlaylayers[key];
        if (previous && this.map.hasLayer(previous)) {
          this.map.removeLayer(previous);
        }
        if (config.visible !== false) {
          this.map.addLayer(layer);
        }
        this.layers.overlaylayers[key] = layer;
        this.activeLayers[key] = true;
        this.manageLegend();
      }, error => console.error(`Could not load ${key}`, error));
    }
  }

  manageLegend() {
    if (!this.gisdataService.isEmptyObj(this.otherOptions.legend))
      this.otherOptions.legend = {};
    // console.log("activeLayers",this.activeLayers);
    
    for (const key in this.activeLayers) {
      let layer = this.layers['overlaylayers'][key];
      if (layer) {

        if (!isNullOrUndefined(layer['options']['hasLegend']) || !isNullOrUndefined(layer['options']['legendName'])) {
          if (this.activeLayers[key]) {
            this.otherOptions['legend'][layer['options']['legendName']] = this.legendList[layer['options']['legendName']];
          }
          else {
            for (const i in this.legendList) {
              if (i == layer['options']['legendName'] && layer['options']['name'] != 'Village' && layer['options']['name'] != 'ADA' && layer['options']['name'] != 'Krishi Bhavan' && layer['options']['name'] != 'LAC') {
                delete this.otherOptions.legend[i];
              }
            }
          }
        }
      }
      if (this.params.component == 'CROPGROWTH' || this.params.component == 'CROPGROWTHANALYSIS') {
        if (this.params.locationType == 'user-defined') {
          let aoiLayers: any = this.layers.aoiLayers[key];
          if (!isNullOrUndefined(aoiLayers)) {
            if (!isNullOrUndefined(aoiLayers['options']['hasLegend']) || !isNullOrUndefined(aoiLayers['options']['legendName'])) {
              if (this.activeLayers[key]) {
                this.otherOptions.legend[aoiLayers['options']['legendName']] = this.legendList[aoiLayers['options']['legendName']];
              }
            }
          }
        }
      }
    }
    this.addLegend();
  }
  addLegend() {
    this.createLegend();
    let legendData;
    legendData = this.otherOptions['legend'];
    let legendValue;
    for (let key in legendData) {
      if (legendData[key]) {
        legendValue = this.getLegendData(legendData[key]);
        this.htmlNewLegend.addLegend(legendValue);
      }
    }
    this.checkLegendEvent();
  }

  createLegend() {
    this.removeUpdatedLegend();
    this.htmlNewLegend = new (L as any).Control.HtmlLegendForVisibility({
      position: 'bottomright',
      collapseSimple: false,
      detectStretched: false,
      collapsedOnInit: false,
      showByDefault: true
    });
    if (!isNullOrUndefined(this.htmlNewLegend)) {
      this.map.addControl(this.htmlNewLegend);
    }
  }

  removeUpdatedLegend() {
    if (this.htmlNewLegend) {
      this.map.removeControl(this.htmlNewLegend);
      this.htmlNewLegend.clearLegend();
    }
  }

  getLegendData(data: any, legendName?: any) {

    let legend: any = {
      name: data.Units,
      elements: []
    }
    let isTrue = 1;

    if (isTrue == 1 && data.colorValues && data.colorValues.length > 0) {
      let html: any = `<div class="legend-header-row"><span class="legend-close-btn" data-layer="${legendName ? legendName : data.Units}">&times;</span></div>`, color;
      color = '#ffffff';
      for (let key = 0; key < data.colorValues.length; key++) {
        if (data.colorValues[key]['image']) {
          // html += `<p>${data.colorValues[key].max}</p>`;
          // html = data.HTML ? data.HTML : "<p><img src='" + data.colorValues[key]['image'] + "'/></p>";
          //   html = data.HTML ? data.HTML : `
          //   <div class='d-flex gap-2'>
          //   <img class='d-block h-200px' src="${data.colorValues[key]['image']}"/>
          //     <div class='h-200px d-flex flex-column justify-content-between'>
          //       <p class='m-0'>${data.colorValues[key].max}</p>
          //       <p class='m-0'>${data.colorValues[key].min}</p>
          //     </div>
          // </div>
          //   `;
          // html += `<p>${data.colorValues[key].min}</p>`;
          // if (data.colorValues[key]['image'] === '../../../../../assets/imgs/visibilityDashboards/miTanks/MITankPolygon.png') {
          // } else {
          html += `<div class="d-flex align-items-center p-2"><img  src='${data.colorValues[key].image}' class="ml-1 mr-2"></><p class="m-0">${data.colorValues[key].text}</p></div>`;
          // }
        } else {
          if (this.routeParams.component != "humidityForecast" && this.routeParams.component != "temperatureForecast" && this.routeParams.component != "temperatureActual" && this.routeParams.component != "humidityActual") {
            if (key == 0) {
              html += `<div class="d-flex flex-wrap" style="gap: 2px; margin-top: 5px;">`;
            }
            if (data.colorValues[key].backgroundColor) {
              html += `<div style="background-color:${data.colorValues[key].backgroundColor}; color:${data.colorValues[key].textColor ? data.colorValues[key].textColor : '#000'};
                height: 30px; min-width: 60px; padding: 0 4px; display: flex; align-items: center; justify-content: center;
                border-radius: 4px; font-size: 10px; font-weight: 600; text-align: center; border: 1px solid rgba(0,0,0,0.1); flex: 1 1 auto; max-width: 100px;">
                ${data.colorValues[key].text}
              </div>`;
            }
            if (key == data.colorValues.length - 1) {
              html += `</div>`;
            }

            if (data.colorValues[key].borderColor) {
              html += `<div class="d-flex align-items-center" style="gap: 8px; margin-top: 5px;">
                <span style='border: 2px solid ${data.colorValues[key].borderColor}; background-color: #FFFFFF; border-radius: 50%; width: 12px; height: 12px; display: inline-block;'></span>
                <p class="m-0" style="font-size: 11px; font-weight: 600;">${data.colorValues[key].text}</p>
              </div>`;
            }
          }
          // else if(this.routeParams.component == 'geoportal'){
          //    html += `<div><img  src='${data.colorValues[key].imgurl}'></><p>${data.colorValues[key].text}</p></div>`;
          // }
          else {
            if (key == 0) {
              html += `<div class="d-flex flex-wrap" style="gap: 2px; margin-top: 5px;">`;
            }
            html += `<div style="background-color:${data['colorValues'][key]['backgroundColor']} ; color:${data.colorValues[key].textColor ? data.colorValues[key].textColor : '#000'};
              height: 30px; min-width: 70px; padding: 0 5px; display: flex; align-items: center; justify-content: center;
              border-radius: 4px; font-size: 11px; font-weight: 600; text-align: center; border: 1px solid rgba(0,0,0,0.1);">
              ${data.colorValues[key].text}
            </div>`;
            if (key == data.colorValues.length - 1) {
              html += `</div>`;
            }
          }

          // html +=  `<div class="my-0 font-weight-bold text-center" style="background-color:' + ${data.colorValues[key].backgroundColor}+ ' ; color:' + data.colorValues[key].text} + '"><span style="postition = absolute; padding:0,20px;">' + ranges[i].text + '</span></div>`;
        }
      }
      legend['elements'].push({ html: html });

    } else if (data.HTML || data.image) {
      let html = data.HTML ? data.HTML : "<img src='" + data.image + "'/>";
      legend.elements.push({ html: html });
    }
    return legend;
  }

  checkLegendEvent() {
    let legendEvent: any = document.getElementsByClassName('leaflet-legend-close')[0];
    if (legendEvent) {
      legendEvent.addEventListener("click", (event: any) => {
        this.alterLegendStyle();
      });
    }

    // Handle custom close buttons in legend rows
    const closeBtns = document.querySelectorAll('.legend-close-btn');
    closeBtns.forEach((btn: any) => {
      btn.addEventListener('click', (event: any) => {
        const layerName = event.target.getAttribute('data-layer');
        if (layerName) {
          this.gisUtils.nhipLayerToggle.next(layerName);
        }
      });
    });
  }

  alterLegendStyle() {
    let legendElem: any = document.getElementsByClassName('leaflet-control leaflet-legend')[0];
    let elems: any = legendElem.style.transform.split(',');
    if (elems && elems[1] && elems[1].split('px').length > 0) {
      let val: any = Number(elems[1].split('px')[0]);
      if (val > 115 || val < -350) {
        // legendElem.style = "margin-bottom: 0px; transform: translate3d(-118.564px, 44.7731px, 0px);";
        // legendElem.style.transform = "";
        // legendElem.setAttribute("style","margin-bottom: 0px;");
        this.addLegend();
        let legendClose: any = document.getElementsByClassName('leaflet-legend-close')[0];
        legendClose.click();
      }
    }
  }

  ngOnDestroy() {
    if (this.paramsSubscription) {
      this.paramsSubscription.unsubscribe();
    }
    // Pixi layers hold a WebGL context until removed from the map; free them with the component
    for (const key in this.layers.overlaylayers) {
      const layer = this.layers.overlaylayers[key];
      if (this.map && isPixiPointsLayer(layer) && this.map.hasLayer(layer)) {
        this.map.removeLayer(layer);
      }
    }
    // if (this.aoiParamsSubscription) {
    //   this.aoiParamsSubscription.unsubscribe();
    // }
    // if(this.dataTabSubscription) {
    //   this.dataTabSubscription.unsubscribe();
    // }
    // if(this.enableToolSubscription) {
    //   this.enableToolSubscription.unsubscribe();
    // }
  }

  removeComponentWiseLayers() {
    for (const key in this.layers.overlaylayers) {
      let layer = this.layers.overlaylayers[key]['options'];
      if (layer['component'] && (layer['component'] == this.params['component'])) {
        if (this.map.hasLayer(this.layers.overlaylayers[key])) {
          this.map.removeLayer(this.layers.overlaylayers[key])
        }
        delete this.layers.overlaylayers[key];
      }
    }
  }

  removeAllLayers() {
    for (const key in this.layers.overlaylayers) {
      if (this.map.hasLayer(this.layers.overlaylayers[key])) {
        this.map.removeLayer(this.layers.overlaylayers[key]);
      } else if (this.map.hasLayer(this.layers.overlaylayers[key]['layer'])) {
        // this.map.removeLayer(this.layers.overlaylayers[key]['layer'])
      }
      delete this.layers.overlaylayers[key];
    }

    if (Object.keys(this.layers.processedLayers).length > 0) {
      for (const key in this.layers.processedLayers) {
        let processedLayer = this.layers.processedLayers[key];
        if (processedLayer) {
          for (const elem in processedLayer) {
            if (this.layers.processedLayers[key][elem].layerConfig && this.map.hasLayer(this.layers.processedLayers[key][elem].layerConfig)) {
              this.map.removeLayer(this.layers.processedLayers[key][elem].layerConfig);
            }
          }
        }
        delete this.layers.processedLayers[key];
      }
    }
  }

  removeAllLayersExceptNHIP() {
    for (const key in this.layers.overlaylayers) {
      if (this.layers.overlaylayers[key].options['group'] != 'Hazard') {
        if (this.map.hasLayer(this.layers.overlaylayers[key])) {
          this.map.removeLayer(this.layers.overlaylayers[key]);
        }
        delete this.layers.overlaylayers[key];
      }
    }
  }

  removeHeatMapLayers() {
    if (Object.keys(this.layers.aoiLayers)) {
      Object.keys(this.layers.aoiLayers).forEach((layerName: any) => {
        const layer: any = this.layers.aoiLayers[layerName].options;
        if (layer.component && layer.component == this.params.component) {
          if (this.map.hasLayer(this.layers.aoiLayers[layerName])) {
            this.map.removeLayer(this.layers.aoiLayers[layerName]);
          }
          delete this.layers.aoiLayers[layerName];
        }
      });
    }
  }

  addCoordinates() {
    const Coordinates = L.Control.extend({
      onAdd: (map: any) => {
        const container = L.DomUtil.create("div");
        // container.className = 'latlng-mousehover';
        map.addEventListener("mousemove", (e: any) => {

          container.innerHTML = `
          <span class='latlng-mousehover'>Lat:
            ${e.latlng.lat.toFixed(
            6
          )} <br>Long:  ${e.latlng.lng.toFixed(6)}
            </span>
          `;
        });
        return container;
      }
    });

    this.map.addControl(new Coordinates({ position: "bottomleft" }));
  }

  // dataTabToggle() {
  //   this.dataTabToggleVal = !this.dataTabToggleVal
  //   this.revalidateMap()
  // }
  dataTabToggle() {
    this.dataTabToggleVal = !this.dataTabToggleVal;

    if (this.dataTabToggleVal) {
      const params = this.queryParams && this.queryParams.params
        ? this.queryParams.params
        : null;

      if (params && params.locType === 'STATE') {
        this.gisUtils.setViewForNHIPAlert.next({
          locType: 'STATE',
          stateUUID: params.pUUID,
          locName: params.locName,
          lat: this.map.getCenter().lat,
          lng: this.map.getCenter().lng
        });
      }
    }

    this.revalidateMap();
  }

  activeMenu(event: any) {
    this.activeSideMenu = event;
  }

  changeTimeLayers(groupName) {
    if (this.componentType != 'thunderstorm' && this.componentType != 'nowcast' && this.componentType != 'kolkata-nowcast' && !this.componentType.includes('forecast')) {
      this.blockNumber = this.dateBlockNumMap[parseInt(groupName, 10)];
    } else if (this.componentType.includes('forecast')) {
      if (groupName != ' 24hr') {
        this.counter = parseInt(groupName, 10);
        if (!this.componentType.includes('windspeed') && this.queryParams['params']['forecastLength'] == '10') {
          this.blockNumber = Math.floor(
            (this.counter - this.initialCounter) / 86400000
          );
        } else if (this.componentType == 'windspeed-forecast' && this.queryParams['params']['forecastLength'] == '10') {
          this.blockNumber = Math.floor(
            // (this.counter - this.initialCounter) / 10800000
            (this.counter - this.initialCounter) / 21600000
          );
        } else {
          this.blockNumber = Math.floor(
            (this.counter - this.initialCounter) / 10800000
            // (this.counter - this.initialCounter) / 21600000
          );
        }
      } else {
        this.blockNumber = 8;
      }
    } else if (this.queryParams['params']['forecastLength'] == '24') {
      this.counter = parseInt(groupName, 10)
      this.blockNumber = groupName != '24hr' ? Math.floor(
        (this.counter - this.initialCounter) / 10800000) : 8;
    } else if (this.queryParams['params']['forecastLength'] == '10') {
      this.blockNumber = Math.floor(
        (this.counter - this.initialCounter) / 86400000);
    } else if (this.componentType == 'nowcast' || this.componentType == 'kolkata-nowcast') {
      this.counter = parseInt(groupName, 10);
      if (this.selectedSource == 'JAXA') {
        this.blockNumber = Math.floor(
          (this.counter - this.initialCounter) / 3600000 // 1 hour in milliseconds
        );
      } else if (this.selectedSource != 'EUMETSAT') {
        this.blockNumber = Math.floor(
          (this.counter - this.initialCounter) / 600000 // 10 minutes in milliseconds
        );
      } else if (this.selectedSource == 'EUMETSAT') {
        this.blockNumber = Math.floor(
          (this.counter - this.initialCounter) / 900000 // 15 minutes in milliseconds
        );
      }
    }
    console.log("BLOCKNUMBER::", this.blockNumber, this.initialCounter);
    this.injectedService[this.otherOptions['animationLayers']](this, groupName)
  }

  changePlayPos(event: any) {
    this.playPosition = event;
  }

  heatWaveReport() {
    this.showThrobber = true;
    const source = this.queryParams['params']['source'] || 'IMD_LONG_RANGE'; // Default to 'IMD_LONG_RANGE' if no source is selected

    if (this.queryParams['params']['locType'] === 'COUNTRY') {
      this.mapService.getStateHeatWaveDownload(source).subscribe(
        (data) => this.downloadReport(data, 'Heat_Wave'),     // country level
        (error) => {
          console.error('Error downloading the report:', error);
          this.showThrobber = false;
        }
      );
    } else if (this.queryParams['params']['locType'] === 'STATE' || this.queryParams['params']['locType'] === 'DISTRICT') {
      let allLocations = this.queryParams['params']['location'].split('&')[1]
      let districtUUID = allLocations.split('##')[1]
      this.mapService.getHeatWaveDownload(districtUUID).subscribe(
        (data) => this.downloadReport(data, 'Heat_Wave'), // state level
        (error) => {
          console.error('Error downloading the report:', error);
          this.showThrobber = false;
        }
      );
    }
  }

  coldWaveReport() {
    this.showThrobber = true;
    const source = this.selectedSource || 'IMD_LONG_RANGE'; // Default to 'IMD_LONG_RANGE' if no source is selected

    if (this.queryParams['params']['locType'] === 'COUNTRY') {
      this.mapService.getCountryColdWaveDownload(source).subscribe(
        (data) => this.downloadReport(data, 'Cold_Wave'),     // country level
        (error) => {
          console.error('Error downloading the report:', error);
          this.showThrobber = false;
        }
      );
    } else if (this.queryParams['params']['locType'] === 'STATE' || this.queryParams['params']['locType'] === 'DISTRICT') {
      let allLocations = this.queryParams['params']['location'].split('&')[1]
      let districtUUID = allLocations.split('##')[1]
      this.mapService.getColdWaveDownload(districtUUID).subscribe(
        (data) => this.downloadReport(data, 'Cold_Wave'), // state level
        (error) => {
          console.error('Error downloading the report:', error);
          this.showThrobber = false;
        }
      );
    }
  }

  private downloadReport(data: Blob, fileName: any) {
    const filename = fileName + "_Report" + ".pdf";
    const PDF_TYPE = "application/pdf;charset=utf-8";
    if (!data) {
      this.showThrobber = false;
      return;
    }
    const blob = new Blob([data], { type: PDF_TYPE });
    const objectUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    a.target = "_blank";
    a.click();
    setTimeout(() => {
      this.showThrobber = false;
    });
  }

  routeChange(type: any) {
    let options = { ... this.queryParams }
    options['view'] = type;
    options['locName'] = "India"
    options['locType'] = "COUNTRY"
    options['location'] = "India##00cb31c7-2928-4e6d-adcc-443d478c90d6"
    options['pUUID'] = "00cb31c7-2928-4e6d-adcc-443d478c90d6"
    this.activeButton = type
    this.router.navigate(['/nowcastweather/nowcast/akbm'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    })
  }

  routeToNowcast() {
    this.router.navigate(['', 'nowcastweather', 'forecast', 'akbm'])
  }

  layerToggle(type: any) {
    this.actualView = type
    this.injectedService[this.otherOptions['changeAnimationLayer']](this)
  }

  handleEventFromSearch(data) {
    this.map.flyTo(
      [data.location.lat, data.location.long],
      ProjConstants.LOCATION_ZOOM_MAPPING[data["et"]]
    );
  }

  toggleLayerList() {
    this.isLayerListClick = !this.isLayerListClick
  }

  showAndHideLayer(layer, source) {
    if (this.map.hasLayer(layer.value.layer)) {
      this.map.removeLayer(layer.value.layer)
      layer.value.visible = !layer.value.visible
    }
    else {
      this.map.addLayer(layer.value.layer)
      layer.value.visible = true
    }
  }

  showAndHideStationQCLayer(type, event) {
    Object.keys(this.stationlayerType).forEach(key => {
      if (key == type) {
        this.stationlayerType[key] = true
      }
      else {
        this.stationlayerType[key] = false
      }
    })
    for (let i in this.layers.stationlayersQC) {
      let layer = this.layers.stationlayersQC[i]
      if (this.stationlayerType[type] && type == 'Valid Stations' && layer['name'] == 'Invalid Stations') {
        this.map.removeLayer(layer['layer'])
      } else if (this.stationlayerType[type] && type == 'Invalid Stations' && layer['name'] == 'Valid Stations') {
        this.map.removeLayer(layer['layer'])
      }
      if (layer.name == type && this.map.hasLayer(layer['layer']) && !event.target.checked) {
        this.map.removeLayer(layer['layer'])
      } else if (layer.name == type && !this.map.hasLayer(layer['layer']) && event.target.checked && this.rfActualQCSrcList[layer['source']]) {
        this.map.addLayer(layer['layer'])
      }
    }
  }

  onCheckboxChange(item, event) {
    this.rfActualQCSrcList[item] = event.target.checked;
    for (let i in this.layers.stationlayersQC) {
      let layer = this.layers.stationlayersQC[i]
      if (layer['source'] == item && this.map.hasLayer(layer['layer']) && !event.target.checked) {
        this.map.removeLayer(layer['layer'])
      } else if (layer['source'] == item && !this.map.hasLayer(layer['layer']) && event.target.checked && this.stationlayerType[layer['name']]) {
        this.map.addLayer(layer['layer'])
      }
    }
  }

  moveToValidState() {
    this.injectedService['moveStationsToValidStateOnClick'](this)
  }

  toggleImageSlider() {
    this.isImageSliderOpen = !this.isImageSliderOpen
  }

  openDisasterTable() {
    this.injectedService['openDisasterTablePopup'](this)
  }
  goToLandingPage() {
    this.router.navigate(['landing-page']);
  }

  downloadImage(type?: string): Promise<string> {
    return new Promise(async (resolve, reject) => {
      try {
        this.showMapThrobber = true;
        const node = document.getElementById(this.mapId);
        if (!node) {
          reject('Map node not found');
          return;
        }
        // Ensure map finished rendering
        await new Promise(r => setTimeout(r, 1200));
        const filter = (node: HTMLElement) => {
          if (node.classList) {
            return false;
          }
          return true;
        };
        const options: any = {
          quality: 1,
          filter,
          width: node.clientWidth,
          height: node.clientHeight,
        };
        let dataUrl;
        if (type === 'jpeg') {
          dataUrl = await domtoimage.toJpeg(node, options);
        } else {
          dataUrl = await domtoimage.toPng(node, options);
        }
        resolve(dataUrl);
      } catch (error) {
        console.error('Map capture failed:', error);
        reject(error);
      } finally {
        // this.gisMapComp.showThrobber = false;
      }
    });
  }

}
